const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const accountsActions = require('actions/getAccounts');
const receivedTransfersActions = require('actions/receivedTransfers');

// @components
const ReceivedTransfers = require('components/transfers/received/receivedTransfers/receivedTransfers');
const TransfersMoreOptionsButton = require('components/transfers/transfersMoreOptionsButton/transfersMoreOptionsButton')
const TransfersOptionsButton = require('components/transfers/transfersOptionsButton/transfersOptionsButton');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');

// @utilities
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @constants
const { GRAPHIC_TUTOR_TYPE_3 } = require('constants/index');

class TransfersReceivedView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        this.props.requestAccounts();
    }

    render() {
        const {
            clearFilters,
            immAccounts,
            immReceivedTransfers,
            immScreen,
            setFilters,
            match: {params: { accountId }},
            requestReceivedTransfers,
            requestReceivedTransfersNextPage,
            resetFilter
        } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('transfersLanding-receivedTranfers')
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_3}
                title={formatText('tutorials-transfersReceivedTitle')}
            />
        );
        let moreOptionsButton;
        let optionsButton;
        let content;

        if (immAccount) {
            moreOptionsButton = (<TransfersMoreOptionsButton immAccount={immAccount} />);
            optionsButton = (<TransfersOptionsButton immAccount={immAccount} />);
            content = (
                <ReceivedTransfers
                    immAccount={immAccount}
                    immAccounts={immAccounts}
                    immReceivedTransfers={immReceivedTransfers}
                    immScreen={immScreen}
                    requestReceivedTransfers={requestReceivedTransfers}
                    setFilters={setFilters}
                    resetFilter={resetFilter}
                    clearFilters={clearFilters}
                    requestReceivedTransfersNextPage={requestReceivedTransfersNextPage}
                />
            );
        } else {
            content = <LoadingSection />;
        }

        const transfersReceivedClassName = contactCenterClassName('transfers-received-view')
        const transfersReceivedBodyClassName = contactCenterClassName('transfers-received-view__body', 'grid-view__body')

        return (
            <div className={transfersReceivedClassName}>
                <div className="container-fluid">
                    <div className="row transfers-received-view--header-identifier">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('transfersLanding-receivedTranfers')}>
                                {moreOptionsButton}
                                {optionsButton}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className={transfersReceivedBodyClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <OKSectionBox>
                                    {content}
                                </OKSectionBox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TransfersReceivedView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immReceivedTransfers: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestAccounts: PropTypes.func.isRequired,
    requestReceivedTransfers: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    requestReceivedTransfersNextPage: PropTypes.func.isRequired
};

module.exports.constructor = TransfersReceivedView;
module.exports.TransfersReceivedView = connect(
    state => ({
        immAccounts: state.accounts,
        immReceivedTransfers: state.receivedTransfers,
        immScreen: state.screen,
    }), {
        requestAccounts: accountsActions.requestAccounts,
        requestReceivedTransfers: receivedTransfersActions.requestReceivedTransfers,
        setFilters: receivedTransfersActions.setReceivedTransfersFilters,
        resetFilter: receivedTransfersActions.resetReceivedTransfersFilter,
        clearFilters: receivedTransfersActions.clearReceivedTransfersFilters,
        requestReceivedTransfersNextPage: receivedTransfersActions.requestReceivedTransfersNextPage
    })(TransfersReceivedView);
